/** Deux barres horizontales : cette période vs avant. */
import { ProgressBar } from "./ProgressBar";
import { formatEuroHt } from "./period";

type CompareStripProps = {
  current: number | null;
  previous: number | null;
  format?: (n: number | null) => string;
};

export function CompareStrip({ current, previous, format = formatEuroHt }: CompareStripProps) {
  const max = Math.max(current ?? 0, previous ?? 0, 1);
  return (
    <div className="fx-compare">
      <div className="fx-compare__row">
        <span>Cette période</span>
        <ProgressBar
          key={`c-${current}`}
          value={current === null ? 0 : (current / max) * 100}
          label="Cette période"
        />
        <strong>{format(current)}</strong>
      </div>
      <div className="fx-compare__row">
        <span>Période d’avant</span>
        <ProgressBar
          key={`p-${previous}`}
          value={previous === null ? 0 : (previous / max) * 100}
          tone="muted"
          label="Période d’avant"
        />
        <strong>{format(previous)}</strong>
      </div>
    </div>
  );
}
